import { LANGUAGE_DEFAULT } from '../consts/data'
import {
    SET_LANGUAGE,
    SET_POSSIBLE_DEPARTURES,
    SET_POSSIBLE_DESTINATIONS,
    SET_POSSIBLE_TRANSPORTS,
    SET_POPULAR_DESTINATIONS,
} from '../actions/dataActions'

const initialState = {
    lang: LANGUAGE_DEFAULT,
    popularDestinations: [],
    possibleDestinations: [],
    possibleDepartures: [],
    possibleTransports: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return { ...state, lang: action.payload }
        case SET_POPULAR_DESTINATIONS:
            return { ...state, popularDestinations: action.payload }
        case SET_POSSIBLE_DESTINATIONS:
            return { ...state, possibleDestinations: action.payload }
        case SET_POSSIBLE_DEPARTURES:
            return { ...state, possibleDepartures: action.payload }
        case SET_POSSIBLE_TRANSPORTS:
            return { ...state, possibleTransports: action.payload }
        default:
            return state
    }
}
